import { Icon } from "@/ds";
import { useTheme } from "@/lib/useTheme";

/**
 * Light/dark switch. Sits in the ink navbar, so it is styled on the on-ink
 * tokens rather than the page foreground.
 */
export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const next = theme === "dark" ? "light" : "dark";

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={`Switch to ${next} theme`}
      title={`Switch to ${next} theme`}
      className="inline-flex items-center justify-center w-[36px] h-[36px] rounded-md border border-border-on-ink text-on-ink-body hover:text-on-ink hover:border-on-ink transition-colors duration-160 ease-out cursor-pointer"
    >
      <Icon name={theme === "dark" ? "sun" : "moon"} size={16} />
    </button>
  );
}
